/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from '@/application';
import { getAgent } from './agent';

const is = require('is_js');

const SERVICE_NAME = 'UsersListPageService';

export class OrgComplianceListPageService {
  private static instance: OrgComplianceListPageService;
  private vapp: VApplication;
  private loginRestAPI: string;
  private criteria: any;
  private headers: any;
  private token: string;
  private userRoles: any;

  private constructor(props: any = {}) {
    this.vapp = VApplication.getInstance();
    this.loginRestAPI = props?.loginRestAPI;
    this.headers = props?.headers;
    this.token = props?.token;
    this.userRoles = props?.userRoles;
  }

  public static getInstance(props: any = {}): OrgComplianceListPageService {
    if (!OrgComplianceListPageService.instance) {
      OrgComplianceListPageService.instance = new OrgComplianceListPageService(
        props
      );
    }
    return OrgComplianceListPageService.instance;
  }

  private setCriteria(data: any) {
    this.criteria = [...this.criteria, ...data];
  }

  public resetCriteria() {
    this.criteria = [];
  }

  public getStaticPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = agent.getStaticPageContentSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }

  public async getPageContent(args: any) {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    if (args?.criteria) {
      this.setCriteria(args?.criteria);
    }

    //Settings Props
    compProps = await agent.getSettingsProps({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    //UserLists Props
    compProps = await agent.getOrgCompliance({
      ...args,
    });
    this.userRoles = compProps?.userRoles;

    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }

  public async createOrgCompliance(args: any) {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = await agent.createOrgCompliance({
      ...args,
    });

    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }
}
